import { IRichTextBlockModel } from 'models/blockRichText.model'
import { IEvaluationQuestion } from 'models/evaluation.model'
import { IMeetingBlockModel } from 'models/block.model'
import { MeetingTypes } from 'enum/meetingTypes.enum'
import { MeetingIntegrationTypes } from 'enum/meetingIntegrationTypes.enum'
import { createAction } from '../../helpers/redux-actions.helper'
import { ActionsUnion } from '../../helpers/types.helper'
import {
  ISurveyBlockModel,
  IEvaluationBlockModel,
  IMultimediaBlockModel,
  ITaskBlockModel,
  IScormBlockModel,
} from '../../models/block.model'

// CREATE
export const SURVEY_BLOCK_CREATE = 'SURVEY_BLOCK_CREATE'
export const RICHTEXT_BLOCK_CREATE = 'RICHTEXT_BLOCK_CREATE'
export const TASK_BLOCK_CREATE = 'TASK_BLOCK_CREATE'
export const MULTIMEDIA_BLOCK_CREATE = 'MULTIMEDIA_BLOCK_CREATE'
export const EVALUATION_BLOCK_CREATE = 'EVALUATION_BLOCK_CREATE'
export const BLOCK_CREATE_SUCCESS = 'BLOCK_CREATE_SUCCESS'
export const SCORM_BLOCK_CREATE = 'SCORM_BLOCK_CREATE'
export const MEETING_BLOCK_CREATE = 'MEETING_BLOCK_CREATE'
// READ
export const GET_LESSON_BLOCKS_LIST = 'GET_LESSON_BLOCKS_LIST'
export const GET_LESSON_BLOCKS_LIST_SUCCESS = 'GET_LESSON_BLOCKS_LIST_SUCCESS'
export const GET_EVALUATION_DATA = 'GET_EVALUATION_DATA'
export const GET_EVALUATION_DATA_SUCCESS = 'GET_EVALUATION_DATA_SUCCESS'
// UPDATE
export const EDIT_SURVEY_BLOCK_DETAILS = 'EDIT_SURVEY_BLOCK_DETAILS'
export const EDIT_RICHTEXT_BLOCK = 'EDIT_RICHTEXT_BLOCK'
export const EDIT_TASK_BLOCK = 'EDIT_TASK_BLOCK'
export const EDIT_MULTIMEDIA_BLOCK = 'EDIT_MULTIMEDIA_BLOCK'
export const EDIT_EVALUATION_BLOCK = 'EDIT_EVALUATION_BLOCK'
export const EDIT_BLOCK = 'EDIT_BLOCK'
export const BLOCK_ORDER_EDIT = 'BLOCK_ORDER_EDIT'
export const BLOCK_LOADING = 'BLOCK_LOADING'
export const EDIT_SCORM_BLOCK = 'EDIT_SCORM_BLOCK'
export const EDIT_MEETING_BLOCK = 'EDIT_MEETING_BLOCK'
// DESTROY
export const DESTROY_SURVEY_BLOCK = 'DESTROY_SURVEY_BLOCK'
export const DESTROY_RICHTEXT_BLOCK = 'DESTROY_RICHTEXT_BLOCK'
export const DESTROY_TASK_BLOCK = 'DESTROY_TASK_BLOCK'
export const DESTROY_MULTIMEDIA_BLOCK = 'DESTROY_MULTIMEDIA_BLOCK'
export const DESTROY_EVALUATION_BLOCK = 'DESTROY_EVALUATION_BLOCK'
export const DESTROY_SCORM_BLOCK = 'DESTROY_SCORM_BLOCK'
export const DESTROY_MEETING_BLOCK = 'DESTROY_MEETING_BLOCK'

// OTHER
export const CLEAR_EDIT = 'CLEAR_EDIT'

export type EditMeetingBlockPayload = {
  lessonId: number
  id: number
  title: string
  description: string
  startTime: string | null
  duration: number
  typeMeet: MeetingTypes
  timezone: string
  integrationType: MeetingIntegrationTypes
  config: {
    host: { 
      name: string
      email: string 
    }
    panelists: {
      name: string
      email: string
    }[]
  }
}

export const Actions = {
  // CREATE
  createBlockSurveyInstance: (data: ISurveyBlockModel) =>
    createAction(SURVEY_BLOCK_CREATE, data),
  createBlockRichTextInstance: (data: IRichTextBlockModel) =>
    createAction(RICHTEXT_BLOCK_CREATE, data),
  createBlockTaskInstance: (data: ITaskBlockModel) =>
    createAction(TASK_BLOCK_CREATE, data),
  createBlockMultimediaInstance: (data: IMultimediaBlockModel) =>
    createAction(MULTIMEDIA_BLOCK_CREATE, data),
  createBlockEvaluationInstance: (data: IEvaluationBlockModel) =>
    createAction(EVALUATION_BLOCK_CREATE, data),
  createBlockInstanceSuccess: (data: ISurveyBlockModel | IRichTextBlockModel) =>
    createAction(BLOCK_CREATE_SUCCESS, data),
  createBlockScormInstance: (data: IScormBlockModel) =>
    createAction(SCORM_BLOCK_CREATE, data),
  createBlockMeetingInstance: (data: IMeetingBlockModel) =>
    createAction(MEETING_BLOCK_CREATE, data),
  // READ
  getLessonBlocksList: (lessonId: number) =>
    createAction(GET_LESSON_BLOCKS_LIST, lessonId),
  getLessonBlocksListSuccess: (data: ISurveyBlockModel) =>
    createAction(GET_LESSON_BLOCKS_LIST_SUCCESS, data),
  getEvaluationData: (evaluationId: number) =>
    createAction(GET_EVALUATION_DATA, evaluationId),
  getEvaluationDataSuccess: (evaluationData: IEvaluationQuestion) =>
    createAction(GET_EVALUATION_DATA_SUCCESS, evaluationData),
  // EDIT
  editBlockSurveyDetails: (data: ISurveyBlockModel) =>
    createAction(EDIT_SURVEY_BLOCK_DETAILS, data),
  editRichTextBlock: (data: IRichTextBlockModel) =>
    createAction(EDIT_RICHTEXT_BLOCK, data),
  editTaskBlock: (data: ITaskBlockModel) => createAction(EDIT_TASK_BLOCK, data),
  editMultimediaBlock: (data: IMultimediaBlockModel) =>
    createAction(EDIT_MULTIMEDIA_BLOCK, data),
  editEvaluationBlock: (data: IEvaluationBlockModel) =>
    createAction(EDIT_EVALUATION_BLOCK, data),
  editBlockInstance: (data: ISurveyBlockModel | IRichTextBlockModel) =>
    createAction(EDIT_BLOCK, data),
  blocksOrderEdit: (lessonId: number, blocks: number[]) =>
    createAction(BLOCK_ORDER_EDIT, { lessonId, blocks }),
  editScormBlock: (data: IScormBlockModel) =>
    createAction(EDIT_SCORM_BLOCK, data),
  editMeetingBlock: (data: EditMeetingBlockPayload) =>
    createAction(EDIT_MEETING_BLOCK, data),
  // DESTROY
  destroyBlockSurveyInstance: (data: ISurveyBlockModel) =>
    createAction(DESTROY_SURVEY_BLOCK, data),
  destroyRichTextBlockInstance: (data: IRichTextBlockModel) =>
    createAction(DESTROY_RICHTEXT_BLOCK, data),
  destroyTaskBlockInstance: (data: ITaskBlockModel) =>
    createAction(DESTROY_TASK_BLOCK, data),
  destroyMultimediaBlockInstance: (data: IMultimediaBlockModel) =>
    createAction(DESTROY_MULTIMEDIA_BLOCK, data),
  destroyEvaluationBlockInstance: (data: IEvaluationBlockModel) =>
    createAction(DESTROY_EVALUATION_BLOCK, data),
  destroyScormBlockInstance: (data: IScormBlockModel) =>
    createAction(DESTROY_SCORM_BLOCK, data),
  destroyMeetingBlockInstance: (data: IScormBlockModel) =>
    createAction(DESTROY_MEETING_BLOCK, data),
  // OTHER
  clearEdit: () => createAction(CLEAR_EDIT),
  setLoading: (loading: boolean) => createAction(BLOCK_LOADING, loading),
}

export type Actions = ActionsUnion<typeof Actions>
